import styled from "styled-components";
import moment from "moment-timezone";
import { RATypography } from "@/components/customs";
import { Row, Col, Divider } from "antd";
import { CardBookingStatus } from "../../Cards";
import { JET_ONE_SUITES_STATUS, ROYAL_AIR_J1S_TIMEZONE } from "@/config/constants";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { selectFormatDateTimeFull } from "@/stores/slices/authSlice";

export const CardFlightInfo = ({ flight = {}, flightType, onShowConfirmCancel }) => {
	const {
		depart_datetime = "",
		return_datetime = "",
		status,
		passengers,
		fuel_request,
		note,
		lavatory,
		contacts = [],
	} = flight || {};
	const formatDTFull = useSelector(selectFormatDateTimeFull);

	const checkAllowEdit = () => {
		let allow = true;
		if (status === JET_ONE_SUITES_STATUS.CANCELLED || status === JET_ONE_SUITES_STATUS.REJECTED) {
			allow = false;
		}

		return allow;
	};

	const _renderCancelButton = () => {
		const valid = checkAllowEdit();
		if (valid) {
			return (
				<Row justify="center" align="middle">
					<ButtonWrapper
						data-testid="BookingDetailsModal_cancelBookingBtn"
						onClick={() => onShowConfirmCancel()}
					>
						<TextCancel>CANCEL BOOKING</TextCancel>
					</ButtonWrapper>
				</Row>
			);
		}
	};

	return (
		<>
			<Row gutter={[20, 12]}>
				<Col
					span={24}
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "16px",
					}}
				>
					<Row align="middle">
						<Col md={8} xs={9}>
							<RATypography variant="body3" color="#65686F">
								{flightType === "DEPARTURE" ? "Departure time" : "Arrival time"}
							</RATypography>
						</Col>
						<Col md={16} xs={15}>
							<RATypography variant="sub-heading4">
								{moment(flightType === "DEPARTURE" ? depart_datetime : return_datetime)
									.tz(ROYAL_AIR_J1S_TIMEZONE)
									.format(formatDTFull)}
							</RATypography>
						</Col>
					</Row>
					<Row align="middle">
						<Col md={8} xs={9}>
							<RATypography variant="body3" color="#65686F">
								Passenger
							</RATypography>
						</Col>
						<Col md={16} xs={15}>
							<RATypography variant="sub-heading4">{`${passengers ?? 0} PAX`}</RATypography>
						</Col>
					</Row>
					<Row align="middle">
						<Col md={8} xs={9}>
							<RATypography variant="body3" color="#65686F">
								Status
							</RATypography>
						</Col>
						<Col md={16} xs={15}>
							<Row>
								<RATypography variant="sub-heading4">
									<CardBookingStatus status={status} data-testid="BookingDetailsModal_statusBadge" />
								</RATypography>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
			<Divider />
			<WrapperService>
				<div>
					<RATypography variant="sub-heading4">Fueling Request</RATypography>
					<RATypography variant="body3" top="8px" color="#65686F">
						{fuel_request ?? "-"}
					</RATypography>
				</div>
				<div>
					<RATypography variant="sub-heading4">Special Request</RATypography>
					<RATypography variant="body3" top="8px" color="#65686F">
						{note ?? "-"}
					</RATypography>
				</div>
				<div>
					<RATypography variant="sub-heading4">Lavatory</RATypography>
					<RATypography variant="body3" color="#65686F" top="8px">
						{lavatory === "FULL_SERVICE" ? "Yes" : "No"}
					</RATypography>
				</div>
				<div>
					<RATypography variant="sub-heading4" top="2px">
						Additional Contact
					</RATypography>
					<WrapperContacts>
						{contacts?.length > 0
							? contacts.map((contact, index) => (
									<Row key={index}>
										<Col xl={16} lg={16} md={24} sm={24} xs={24}>
											<CardContactSelected contact={contact} />
										</Col>
									</Row>
								))
							: "-"}
					</WrapperContacts>
				</div>
			</WrapperService>
			{_renderCancelButton()}
		</>
	);
};

const CardContactSelected = ({ contact = {} }) => (
	<WrapperContact>
		<Row gutter={[40, 12]}>
			<Col span={12}>
				<RATypography color="#222222" variant="sub-heading4">
					{contact?.name ?? ""}
				</RATypography>
			</Col>
			<Col span={12}>
				<RATypography color="#222222" variant="body3">
					{contact?.phone ? formatPhoneNumberIntl(contact?.phone) : "_"}
				</RATypography>
			</Col>
		</Row>
	</WrapperContact>
);

const WrapperService = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding-bottom: 30px;
`;
const WrapperContact = styled.div`
	padding: 10px 20px 10px 24px;
	min-height: 42px;
	background: #f9f9f9;
	border-radius: 40px;
`;
const WrapperContacts = styled.div`
	width: 100%;
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const TextCancel = styled.div`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
	letter-spacing: 3px;
	text-transform: uppercase;
	color: #bf1a2f;
`;
const ButtonWrapper = styled.div`
	padding: 6px 20px;
	border-radius: 4px;
	cursor: pointer;
	&:hover {
		background-color: #fff2f4;
	}
`;
